import { Hash, Mic2, Radio, Send, Users, type LucideIcon } from 'lucide-react';
import { cn } from '@/lib/utils';

export type LiveTutorialStepId = 'table' | 'speaking' | 'mates' | 'speaker' | 'actions';

export const LIVE_SESSION_TUTORIAL_STEPS: Array<{
  id: LiveTutorialStepId;
  title: string;
  body: string;
  icon: LucideIcon;
}> = [
  {
    id: 'table',
    title: 'Find your table',
    body: 'Your table number sits below the sessions. During an ongoing session, tap a tablemate in the strip above to jump to their card.',
    icon: Hash,
  },
  {
    id: 'speaking',
    title: 'Take the floor',
    body: 'During an ongoing session, tap Start speaking when it’s your turn. Your intro is shared with the table; tap Stop when you finish. If the organiser set a speaking time, the countdown pauses when you stop and continues the next time you speak.',
    icon: Mic2,
  },
  {
    id: 'speaker',
    title: 'Current speaker',
    body: 'When someone speaks, their photo, intro and actions (Gives, Asks, Lead, Notes, Details) appear here so the whole table can follow along.',
    icon: Radio,
  },
  {
    id: 'mates',
    title: 'Table mates',
    body: 'Your card comes first. Tap View details on a card for business details, and use Gives, Asks, Lead, Notes or Details to connect.',
    icon: Users,
  },
  {
    id: 'actions',
    title: 'Gives, Asks, Leads & Notes',
    body: 'Tap Gives or Asks to see what a table-mate offers or needs, and reply to an ask with a lead. Use Lead to send someone a lead directly. Notes stay private to you.',
    icon: Send,
  },
];

export function tutorialStepRing(active: boolean, className?: string) {
  return cn(
    className,
    'transition-[box-shadow,background-color] duration-300',
    active &&
      'relative z-[1] rounded-2xl bg-primary/[0.04] ring-2 ring-primary/50 ring-offset-2 ring-offset-background'
  );
}
